var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseBanner',{staticClass:"trial-banner"},[_c('p',[_vm._v(" Your Pricing has changed as of 1.07.2022 as per the e-mail communication. If you have any questions, please contact michael.z@renderro.com ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }